module.exports = __webpack_public_path__ + "img/logosi.f77985bd.svg";